import React, { ReactNode } from 'react';
import styled from 'styled-components';

const SidePopupSt = {
  Border: styled.div<{ left?: number | string; right?: number | string; top?: number | string; bottom?: number | string; width?: number }>`
    position: absolute;
    z-index: 2;
    left: ${(p) => (typeof p.left === 'number' ? p.left + 'px' : typeof p.left === 'string' ? p.left : 'auto')};
    top: ${(p) => (typeof p.top === 'number' ? p.top + 'px' : typeof p.top === 'string' ? p.top : 'auto')};
    right: ${(p) => (typeof p.right === 'number' ? p.right + 'px' : typeof p.right === 'string' ? p.right : 'auto')};
    bottom: ${(p) => (typeof p.bottom === 'number' ? p.bottom + 'px' : typeof p.bottom === 'string' ? p.bottom : 'auto')};
    width: ${(p) => (p.width ? p.width + 'px' : 'auto')};
    padding: 2px 0;
    border-radius: 14px;
    background: linear-gradient(to right, #0077a6, #00bea3);
    transition: 0.4s;
    &:before {
    }
  `,
  Wrap: styled.div`
    position: relative;
    z-index: 10;
    margin: 0 auto;
    width: calc(100% - 4px);
    border-radius: 12px;
    background: #fff;
  `,
  Inner: styled.div<{ padding?: number[] }>`
    padding: ${(p) =>
      p.padding?.length === 1
        ? p.padding[0] + 'px'
        : p.padding?.length === 2
          ? `${p.padding[0]}px ${p.padding[1]}px ${p.padding[0]}px ${p.padding[1]}px`
          : p.padding?.length === 3
            ? `${p.padding[0]}px ${p.padding[1]}px ${p.padding[2]}px ${p.padding[1]}px`
            : p.padding?.length === 4
              ? `${p.padding[0]}px ${p.padding[1]}px ${p.padding[2]}px ${p.padding[3]}px`
              : '20px'};
  `,
  Toggle: styled.button`
    width: 32px;
    height: 58px;
    position: absolute;
    z-index: 2;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    background: radial-gradient(1350.52% 793.87% at 65.63% 50%, #0077a6 3.25%, #00bea3 100%);
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-right: 0;
    border-radius: 10px 0 0 10px;
    &:after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) rotate(135deg) skew(-5deg, -5deg);
      content: '';
      width: 10px;
      height: 10px;
      border-left: 2px solid #fff;
      border-top: 2px solid #fff;
    }
    &.hide {
      &:after {
        transform: translate(-50%, -50%) rotate(-45deg) skew(-5deg, -5deg);
      }
    }
  `,
  Title: styled.strong`
    font-weight: 600;
    font-size: 16px;
    color: #091219;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #ddd;
  `,
};

interface SidePopupProps {
  left?: number | string;
  right?: number | string;
  top?: number | string;
  bottom?: number | string;
  isHide?: boolean;
  width?: number;
  children: ReactNode;
  padding?: number[];
  title?: string;
  onHide: () => void;
}
const SidePopup = ({ left, right, top, bottom, width, children, padding, onHide, isHide, title }: SidePopupProps) => {
  return (
    <SidePopupSt.Border left={left} right={right} top={top} bottom={bottom} width={width}>
      <SidePopupSt.Toggle type={'button'} onClick={onHide} className={isHide ? 'hide' : ''}>
        <span className={'hidden'}>보이기/숨기기</span>
      </SidePopupSt.Toggle>
      <SidePopupSt.Wrap>
        <SidePopupSt.Inner padding={padding}>
          {title && <SidePopupSt.Title>{title}</SidePopupSt.Title>}
          {children}
        </SidePopupSt.Inner>
      </SidePopupSt.Wrap>
    </SidePopupSt.Border>
  );
};

export default SidePopup;
